import {
  START_DATE_CHANGED,
  END_DATE_CHANGED,
  EMAIL_CHANGED,
  FETCH_REGISTRATION_LOG_FAILED,
  FETCH_REGISTRATION_LOG_SUCCESS,
  FETCH_REGISTRATION_LOG_STARTED,
  FETCH_REGISTRATION_TIMELINE_FAILED,
  FETCH_REGISTRATION_TIMELINE_SUCCESS,
  FETCH_REGISTRATION_TIMELINE_STARTED,
  FETCH_USER_PROFILE_FAILED,
  FETCH_USER_PROFILE_STARTED,
  FETCH_USER_PROFILE_SUCCESS,
} from '../action-types/registrationLogActionTypes';

const initialState = {
  log: null,
  timeline: null,
  userProfile: null,
  email: null,
  startDate: null,
  endDate: null,
  startDateFormatted: null,
  endDateFormatted: null,
  isLoading: false,
  logError: null,
  timelineError: null,
  userProfileError: null,
  fetchComplete: false,
};

const registrationLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_DATE_CHANGED: {
      return {
        ...state,
        startDate: action.startDate,
        endDate: new Date(action.startDate).getTime() + 86400000,
        startDateFormatted: action.startDate.toLocaleDateString('en-US'),
        endDateFormatted: new Date(
          new Date(action.startDate).getTime() + 86400000
        ).toLocaleDateString('en-US'),
      };
    }
    case END_DATE_CHANGED: {
      return {
        ...state,
        endDate: action.endDate,
        endDateFormatted: action.endDate.toLocaleDateString('en-US'),
      };
    }

    case EMAIL_CHANGED: {
      return {
        ...state,
        email: action.email,
      };
    }

    case FETCH_REGISTRATION_LOG_STARTED: {
      return {
        ...state,
        isLoading: true,
        fetchComplete: false,
        logError: null,
      };
    }

    case FETCH_REGISTRATION_LOG_SUCCESS: {
      return {
        ...state,
        log: action.log,
        isLoading: false,
        fetchComplete: true,
      };
    }
    case FETCH_REGISTRATION_LOG_FAILED: {
      return {
        ...state,
        logError: action.error,
        fetchComplete: false,
        isLoading: false,
      };
    }

    case FETCH_REGISTRATION_TIMELINE_STARTED: {
      return {
        ...state,
        isLoading: true,
        fetchComplete: false,
        timelineError: null,
      };
    }

    case FETCH_REGISTRATION_TIMELINE_SUCCESS: {
      return {
        ...state,
        timeline: action.timeline,
        isLoading: false,
        fetchComplete: true,
      };
    }
    case FETCH_REGISTRATION_TIMELINE_FAILED: {
      return {
        ...state,
        timelineError: action.error,
        fetchComplete: false,
        isLoading: false,
      };
    }

    case FETCH_USER_PROFILE_STARTED: {
      return {
        ...state,
        isLoading: true,
        fetchComplete: false,
        userProfileError: null,
      };
    }

    case FETCH_USER_PROFILE_SUCCESS: {
      return {
        ...state,
        userProfile: action.userProfile,
        isLoading: false,
        fetchComplete: true,
      };
    }
    case FETCH_USER_PROFILE_FAILED: {
      return {
        ...state,
        userProfileError: action.error,
        fetchComplete: false,
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default registrationLogReducer;
